import React from "react";
import { Divider, Typography } from "@mui/material";

import "./index.css";
import aiImages from "./images";

export default function IndustryReportPage() {
  return (
    <div className="report-container">
      {/* Heading */}
      <div className="report-header">
        <Typography variant="h3" className="report-title">
          THE FUTURE OF <br /> GEN AI
        </Typography>

        <Divider className="report-divider" />

        <Typography variant="body1" className="report-subtitle">
          Projections and growth prospects from <br />
          the vantage point of startups.
        </Typography>
      </div>

      <div className="report-grid">
        <img src={aiImages.scopeOfAi} alt="Scope of AI" className="report-image" />
        <img src={aiImages.sectorsOfAi} alt="Sectors of AI" className="report-image" />
        <img src={aiImages.marketOfAi} alt="Market of AI" className="report-image" />
        <img src={aiImages.statsOfAi} alt="Stats of AI" className="report-image" />
        <img src={aiImages.sectorsOfAi2} alt="Sectors of AI Continued" className="report-image" />
        <img src={aiImages.regionalNote} alt="Regional Note on AI" className="report-image" />
      </div>
    </div>
  );
}